export {
  formatAnsweredDate,
  formatAnsweredPollCount,
  getAnsweredQuestionNames,
  type AnsweredPoll,
} from './pollHistory';
